import { OptionalKeys } from '@mews/std';
import { Selector } from './types';

type ExtendedProp<K extends string | number | symbol, V> = { [key in K]: V };

const createPropsExtender =
    <S, P, R, E>(name: keyof E, selector: Selector<S, P, R>) =>
    (state: S, props: typeof name extends keyof P ? OptionalKeys<P, typeof name> : P) =>
        ({
            ...props,
            [name]: selector(state, props as P),
        }) as P & ExtendedProp<typeof name, R>;

export default createPropsExtender;
